(function () {
  const ACTIVE_SCALE = { mobile: 1.1, desktop: 1.1 };

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }

  function applyActiveOverflowShift(swiper) {
    const scaleMax = isDesktopViewport() ? ACTIVE_SCALE.desktop : ACTIVE_SCALE.mobile;
    const sample = swiper.el.querySelector('.sa-showcase-image');
    const slideWidth = sample?.offsetWidth || swiper.slidesSizesGrid?.[0] || 0;
    if (!slideWidth) return;

    const overflow = (slideWidth * (scaleMax - 1)) / 2;

    const activeIndex = swiper.activeIndex;

    swiper.slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      const progress = Number(slide.progress);
      let shift = 0;

      if (!isActive) {
        // Swiper progress: left of active is positive, right is negative.
        // Push neighbors away from the scaled-up active slide.
        if (Number.isFinite(progress) && progress !== 0) {
          shift = -Math.sign(progress) * overflow;
        } else {
          shift = index > activeIndex ? overflow : -overflow;
        }
      }

      slide.style.setProperty('--sa-shift', `${shift}px`);
    });
  }

  function getRealIndex(swiper) {
    if (!swiper) return 0;
    if (typeof swiper.realIndex === 'number') return swiper.realIndex;
    return swiper.activeIndex;
  }

  function createCarouselConfig(root, slideCount) {
    const config = {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 12,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      speed: 700,
      breakpoints: {
        1000: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
      },
      on: {
        init(swiper) {
          requestAnimationFrame(() => applyActiveOverflowShift(swiper));
        },
        slideChange(swiper) {
          applyActiveOverflowShift(swiper);
        },
        slideChangeTransitionEnd(swiper) {
          applyActiveOverflowShift(swiper);
        },
        resize(swiper) {
          applyActiveOverflowShift(swiper);
        },
        breakpoint(swiper) {
          applyActiveOverflowShift(swiper);
        },
      },
    };

    if (slideCount > 3) {
      config.loop = true;
      config.loopedSlides = slideCount;
    }

    if (root.dataset.autoplay === 'true') {
      config.autoplay = {
        delay: Number(root.dataset.autoplayDelay) || 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    return config;
  }

  class SaMediaCarouselModal {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.dataEl = document.getElementById(`sa-media-carousel-data-${this.sectionId}`);
      this.items = this.dataEl ? JSON.parse(this.dataEl.textContent) : [];
      this.modal = root.querySelector('[data-sa-carousel-modal]');
      this.modalSwiperEl = root.querySelector('[data-sa-carousel-modal-swiper]');
      this.modalSwiperWrapper = root.querySelector('.modal-swiper-wrapper');
      this.modalVideoEl = root.querySelector('[data-sa-carousel-modal-video]');
      this.modalPlayBtn = root.querySelector('[data-sa-carousel-modal-play]');
      this.modalAuthorEl = root.querySelector('[data-sa-carousel-modal-author]');
      this.modalReviewEl = root.querySelector('[data-sa-carousel-modal-review]');
      this.modalEngagementEl = root.querySelector('[data-sa-carousel-modal-engagement]');
      this.modalProductsEl = root.querySelector('[data-sa-carousel-modal-products]');
      this.modalSwiper = null;

      this.bindEvents();
    }

    bindEvents() {
      this.root.querySelectorAll('[data-sa-carousel-open-modal]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          this.openModal(Number(trigger.dataset.saCarouselOpenModal));
        });
      });

      this.root.querySelectorAll('[data-close-modal]').forEach((el) => {
        el.addEventListener('click', () => this.closeModal());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) {
          this.closeModal();
        }
      });

      this.modalPlayBtn?.addEventListener('click', () => {
        if (!this.modalVideoEl) return;
        if (this.modalVideoEl.paused) {
          this.modalVideoEl.play();
          this.modalPlayBtn.classList.remove('is-visible');
        }
      });
       // 点击蒙层（弹框内容区域外）关闭
  this.modal?.addEventListener('click', (event) => {
    const dialog = this.root.querySelector('[data-sa-carousel-modal-dialog]');
    if (dialog?.contains(event.target)) return;
    this.closeModal();
  });
    }

    getMediaImages(item) {
      const list = item.images?.length ? item.images : item.cover ? [item.cover] : [];
      return list;
    }

    destroyModalSwiper() {
      if (this.modalSwiper) {
        this.modalSwiper.destroy(true, true);
        this.modalSwiper = null;
      }
    }

    initModalSwiper(images, alt) {
      this.destroyModalSwiper();
      if (!this.modalSwiperWrapper || !this.modalSwiperEl || typeof window.Swiper === 'undefined') return;

      this.modalSwiperWrapper.innerHTML = images
        .map(
          (src) => `
            <div class="swiper-slide flex h-full items-stretch">
              <img class="block h-full w-full object-cover md:hover:scale-105 md:transition-all md:duration-300 md:ease-out" src="${src}" srcset="${src} 1x" alt="${alt}" loading="lazy" />
            </div>
          `,
        )
        .join('');

      this.modalSwiperEl.classList.toggle('is-single', images.length <= 1);

      if (images.length <= 1) return;

      this.modalSwiper = new window.Swiper(this.modalSwiperEl, {
        loop: false,
        speed: 400,
        pagination: {
          el: this.root.querySelector('.modal-swiper__pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.root.querySelector('.modal-swiper__next'),
          prevEl: this.root.querySelector('.modal-swiper__prev'),
        },
      });
    }

    setModalVideo(item) {
      if (!this.modalVideoEl || !this.modalSwiperEl) return;

      if (item.modalType === 'video' && item.videoUrl) {
        this.modalSwiperEl.classList.add('hidden');
        this.modalVideoEl.classList.remove('hidden');
        if (item.cover) this.modalVideoEl.poster = item.cover;
        this.modalVideoEl.src = item.videoUrl;
        this.modalVideoEl.load();
        this.modalPlayBtn?.classList.add('is-visible');
      } else {
        this.modalSwiperEl.classList.remove('hidden');
        this.modalVideoEl.classList.add('hidden');
        this.modalVideoEl.pause();
        this.modalVideoEl.removeAttribute('src');
        this.modalPlayBtn?.classList.remove('is-visible');
      }
    }

    renderAvatars(item) {
      const avatars = [item.authorAvatar, item.authorAvatar2].filter(Boolean);
      if (!avatars.length) return '';

      return `
        <div class="flex items-center">
          ${avatars
            .map(
              (src, index) => `
                <div class="relative size-40 shrink-0 overflow-hidden rounded-full border border-white last:border-black ${index > 0 ? '-ml-12' : ''}" style="z-index: ${index + 1}">
                  <img class="size-full object-cover" src="${src}" alt="" loading="lazy" />
                </div>
              `,
            )
            .join('')}
        </div>
      `;
    }

    renderAuthor(item) {
      if (!this.modalAuthorEl) return;

      const hasAuthor = item.authorName || item.authorDate || item.authorAvatar || item.authorAvatar2;
      if (!hasAuthor) {
        this.modalAuthorEl.innerHTML = '';
        this.modalAuthorEl.classList.add('hidden');
        return;
      }

      const avatarsHtml = this.renderAvatars(item);
      const dateIconUrl = this.root.dataset.dateIconUrl;
      const dateIcon = dateIconUrl
        ? `<img src="${dateIconUrl}" width="20" height="20" alt="" class="h-20 w-20 shrink-0 object-contain" loading="lazy" />`
        : '';

      this.modalAuthorEl.classList.remove('hidden');
      this.modalAuthorEl.innerHTML = `
        <div class="flex flex-col gap-12 md:gap-0">
          <div class="flex items-center gap-8 md:gap-12">
            ${avatarsHtml}
            ${
              item.authorName
                ? `<p class="m-0 break-words text-[14px] leading-20 font-normal font-[Poppins] text-[#000000B2] md:text-[16px] md:font-medium md:leading-24 md:text-[#000000F2]">${item.authorName}</p>`
                : ''
            }
          </div>
          ${
            item.authorDate
              ? `<div class="flex items-center gap-4 md:hidden">
                  ${dateIcon}
                  <span class="truncate text-[14px] leading-20 font-normal font-[Poppins] text-[#00000080]">${item.authorDate}</span>
                </div>
                <p class="mb-16 mt-24 hidden items-center gap-6 text-[14px] leading-20 font-normal text-[#00000080] md:flex">
                  ${dateIcon}
                  <span>${item.authorDate}</span>
                </p>`
              : ''
          }
        </div>
      `;
    }

    renderEngagementItem(label, count, iconUrl, postLink, sizeClass, textClass) {
      const content = `
        <img src="${iconUrl}" alt="" class="${sizeClass} shrink-0" />
        <span>${count}</span>
      `;
      const className = `flex items-center gap-8 text-[14px] leading-20 font-normal font-[Poppins] no-underline transition-opacity hover:opacity-70 ${textClass}`;

      if (postLink) {
        return `<a href="${postLink}" class="${className}" target="_blank" rel="noopener noreferrer" aria-label="${label}">${content}</a>`;
      }

      return `<span class="${className}">${content}</span>`;
    }

    renderEngagement(item) {
      if (!this.modalEngagementEl) return;

      const hasEngagement = item.likesCount || item.commentsCount;
      if (!hasEngagement) {
        this.modalEngagementEl.innerHTML = '';
        this.modalEngagementEl.classList.add('hidden');
        return;
      }

      const likeIconUrl = this.root.dataset.likeIconUrl;
      const reviewsIconUrl = this.root.dataset.reviewsIconUrl;
      const postLink = item.postLink || '';

      this.modalEngagementEl.classList.remove('hidden');
      this.modalEngagementEl.innerHTML = `
        ${
          item.likesCount
            ? this.renderEngagementItem(
                'View post likes',
                item.likesCount,
                likeIconUrl,
                postLink,
                'size-24 max-md:block md:size-20',
                'text-[#000000F2] md:text-[#00000080]',
              )
            : ''
        }
        ${
          item.commentsCount
            ? this.renderEngagementItem(
                'View post comments',
                item.commentsCount,
                reviewsIconUrl,
                postLink,
                'size-24 max-md:block md:size-20',
                'text-[#000000F2] md:text-[#00000080]',
              )
            : ''
        }
      `;
    }

    renderProductCard(product) {
      const compareHtml = product.compareAt
        ? `<span class="text-[12px] font-normal leading-16 font-[Poppins] text-[#00000080] line-through md:text-[14px] md:leading-20">${product.compareAt}</span>`
        : '';

      return `
        <article class="flex items-center gap-8 md:items-stretch md:gap-16">
          <a href="${product.url}" class="size-80 shrink-0 overflow-hidden rounded-[12px] md:h-130 md:w-120 md:size-auto">
            <img
              class="block size-full object-cover"
              src="${product.image}"
              alt="${product.title}"
              loading="lazy"
            />
          </a>
          <div class="flex min-w-0 flex-1 flex-col justify-center gap-4 md:justify-between md:gap-0">
            <h3 class="m-0 text-[12px] font-normal leading-16 font-[Poppins] text-[#000000CC] [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical] overflow-hidden md:text-[16px] md:font-medium md:leading-24 md:text-[#000000F2]">
              <a href="${product.url}" class="text-inherit no-underline">${product.title}</a>
            </h3>
            <div class="flex flex-wrap items-center gap-[2px] md:mt-8 md:items-baseline md:gap-8">
              <span class="text-[14px] font-medium leading-20 font-[Poppins] text-[#000000F2] md:text-[16px] md:font-semibold md:leading-24">${product.price}</span>
              ${compareHtml}
            </div>
            ${product.formHtml || ''}
          </div>
        </article>
      `;
    }

    renderModalProducts(item) {
      if (!this.modalProductsEl) return;

      const products = item.modalType === 'video' ? item.products.slice(0, 1) : item.products.slice(0, 4);
      const productsTitle = this.root.querySelector('[data-sa-carousel-modal-products-title]');
      const productsSection = productsTitle?.parentElement;

      if (!products.length) {
        this.modalProductsEl.innerHTML = '';
        productsSection?.classList.add('hidden');
        return;
      }

      productsSection?.classList.remove('hidden');
      this.modalProductsEl.innerHTML = products.map((product) => this.renderProductCard(product)).join('');
    }

    openModal(index) {
      const item = this.items.find((entry) => entry.index === index);
      if (!item || !this.modal) return;

      if (item.modalType === 'video') {
        this.setModalVideo(item);
      } else {
        this.setModalVideo({ modalType: 'image' });
        this.initModalSwiper(this.getMediaImages(item), item.alt || '');
      }

      this.renderAuthor(item);
      this.renderEngagement(item);
      this.renderModalProducts(item);

      if (this.modalReviewEl) {
        const html = item.reviewText || '';
        const hasText = html.replace(/<[^>]*>/g, '').trim().length > 0;
        this.modalReviewEl.innerHTML = hasText ? html : '';
        this.modalReviewEl.classList.toggle('hidden', !hasText);
      }

      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      this.destroyModalSwiper();
      this.modalVideoEl?.pause();
      this.modalPlayBtn?.classList.remove('is-visible');
    }

    destroy() {
      this.closeModal();
    }
  }

  const instances = new Map();

  function destroySwipers(root) {
    root.querySelectorAll('[data-sa-media-carousel-swiper], [data-sa-carousel-modal-swiper]').forEach((el) => {
      if (el.swiper) el.swiper.destroy(true, true);
      delete el.dataset.swiperInitialized;
    });
  }

  function initCarousel(root) {
    if (typeof window.Swiper === 'undefined') {
      window.setTimeout(() => initCarousel(root), 50);
      return;
    }

    const sectionId = root.dataset.sectionId;

    if (sectionId && instances.has(sectionId)) {
      instances.get(sectionId).destroy();
      instances.delete(sectionId);
    }

    destroySwipers(root);

    const swiperEl = root.querySelector('[data-sa-media-carousel-swiper]');
    if (swiperEl && !swiperEl.swiper && typeof window.Swiper !== 'undefined') {
      const slideCount = Number(swiperEl.dataset.slideCount) || swiperEl.querySelectorAll('.swiper-slide').length;
      if (slideCount > 0) {
        new window.Swiper(swiperEl, createCarouselConfig(root, slideCount));
        swiperEl.dataset.swiperInitialized = 'true';
      }
    }

    const modal = new SaMediaCarouselModal(root);
    if (sectionId) instances.set(sectionId, modal);
  }

  function initAll() {
    document.querySelectorAll('[data-sa-media-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-sa-media-carousel]');
    if (root) initCarousel(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-sa-media-carousel]');
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    instances.get(sectionId)?.destroy();
    instances.delete(sectionId);
  });
})();
